// removed by extract-text-webpack-plugin
module.exports = {"container":"_3CU7r _1-OXK _3Xg8b","deemphasized":"_3wfKq","parameter":"_3XG9o _1-OXK _3Xg8b","nameInput":"_3Ifsg _1-OXK _3Xg8b","fullscreen":"_2Jx9z","name":"_1MEG6 _2gWZX","selected":"_1PVX3","noPopover":"_3Twoq","isEditing":"_1PWke","input":"_24Sc8","parameterButtons":"_3uLCF","editButton":"_12kgT _1-OXK _3Xg8b _1wqBz","removeButton":"_3bQLt _1-OXK _3Xg8b _1wqBz","editNameIconContainer":"_1Zju5"};


//////////////////
// WEBPACK FOOTER
// ./parameters/components/ParameterWidget.css
// module id = 272
// module chunks = 3 4 5